"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const exceptions_1 = require("orbiter-core/src/exceptions");
class MomentRange {
    constructor(start, end) {
        if (start.isAfter(end)) {
            throw exceptions_1.INVALID_DATE_EXCEPTION;
        }
        this.start = start;
        this.end = end;
    }
    getStart() {
        return this.start.clone();
    }
    getEnd() {
        return this.end.clone();
    }
    getDuration() {
        return moment_1.default.duration(this.end.diff(this.start));
    }
}
exports.default = MomentRange;
//# sourceMappingURL=MomentRange.js.map